import React, { useState } from "react";
import { useDraggableSheet } from "../../../helpers/hooks";
// import { IBAN } from "ibankit";

import "./AddBankAccountSection.scss"

function AddBankAccountSection({ onClose }) {
    const [holderName, setHolderName] = useState("");
    const [iban, setIban] = useState("");
    const [bankName, setBankName] = useState("");
    const [inputFocused, setInputFocused] = useState(false);
    const [error, setError] = useState("");

    const { sheetStyle, overlayHandlers } = useDraggableSheet({ onClose });

    const resetError = () => {
        if (error) {
            setError("")
        }
    }

    // const handleAddBankAccount = () => {
    //     if (!IBAN.isValid(iban)) {
    //         return setError("Invalid Iban")
    //     }
    //     const currentIban = new IBAN(iban)

    //     const countryCode = currentIban.getCountryCode();
    //     const currency = currentIban.getCurrencyType()
    //     const accountNumber = currentIban.getAccountNumber();
    //     const accountType = currentIban.getOwnerAccountType();
    //     const bic = currentIban.getBankCode();

    //     if (currency !== "EUR") {
    //         return setError("The only supported currency currently is EUR bank accounts")
    //     }

    //     const body = {
    //         accountNumber, holderName, bankName
    //     }
    // };

    return (
        <div className="add-bank-account-section" {...overlayHandlers}>
            <div
                className={`sheet p-16 ${inputFocused ? "expanded" : ""}`}
                style={sheetStyle}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="main-title pt-16 pb-32">Add bank account</div>

                <div className="input-box d-flex f-column mb-48 gap-16">
                    <input
                        type="text"
                        id="holderName"
                        name="holderName"
                        className="input-field-secondary"
                        value={holderName}
                        onChange={(e) => { setHolderName(e.target.value); resetError(); }}
                        placeholder="Account holder name"
                        required
                        onFocus={() => setInputFocused(true)}
                        onBlur={() => setInputFocused(false)}
                    />
                    <input
                        type="text"
                        id="holderName"
                        name="holderName"
                        className="input-field-secondary"
                        value={bankName}
                        onChange={(e) => { setBankName(e.target.value); resetError(); }}
                        placeholder="Bank name"
                        required
                        onFocus={() => setInputFocused(true)}
                        onBlur={() => setInputFocused(false)}
                    />
                    <input
                        type="text"
                        id="holderName"
                        name="holderName"
                        className="input-field-secondary"
                        value={iban}
                        onChange={(e) => { setIban(e.target.value); resetError(); }}
                        placeholder="IBAN"
                        required
                        onFocus={() => setInputFocused(true)}
                        onBlur={() => setInputFocused(false)}
                    />
                    {error && <div className="error-text">{error}</div>}
                </div>

                <div className="submit-box d-flex f-column aic jcc px-16 py-24">
                    <button
                        onClick={() => { }}
                        type="button"
                        disabled={!iban || !holderName || !bankName}
                        className="btn red-btn btn-full aic jcc fw-bold mb-24"
                    >
                        <span>Save bank account</span>
                    </button>
                    <div onClick={onClose} className="cancel-cta">
                        CANCEL
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddBankAccountSection;
